exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-text[data-v-2d130e0a] {\n  color: #ff0000;\n  display: block;\n}\n.b0[data-v-2d130e0a]{\n  border-bottom: none;\n}\n@media screen and (max-width: 895px) {\n.c-btn-wrap[data-v-2d130e0a] {\n    padding: 4vw;\n}\n}\n@media screen and (min-width: 896px) {\n.form-group[data-v-2d130e0a] {\n    padding-bottom: 0;\n}\n}\n", ""]);

// exports
